import { Card, Grid, Text } from '@mantine/core'
import { formatNumber } from '../../../utils/displayUtils'

type EarningsSummaryCardsProps = {
  totalEarnings: number
  todaysEarnings: number
  thisMonthEarnings: number
}

const EarningsSummaryCards = ({
  totalEarnings,
  todaysEarnings,
  thisMonthEarnings,
}: EarningsSummaryCardsProps) => (
  <Grid gutter='md'>
    <Grid.Col span={{ base: 12, sm: 4 }}>
      <Card shadow='md' radius='md' p='lg' withBorder>
        <Text c='dimmed' fz='sm'>
          All Time Earnings
        </Text>
        <Text fw={700} fz='xl'>
          ${formatNumber(totalEarnings)}
        </Text>
      </Card>
    </Grid.Col>

    <Grid.Col span={{ base: 12, sm: 4 }}>
      <Card shadow='md' radius='md' p='lg' withBorder>
        <Text c='dimmed' fz='sm'>
          This Month's Earnings
        </Text>
        <Text fw={700} fz='xl'>
          ${formatNumber(thisMonthEarnings)}
        </Text>
      </Card>
    </Grid.Col>
    <Grid.Col span={{ base: 12, sm: 4 }}>
      <Card shadow='md' radius='md' p='lg' withBorder>
        <Text c='dimmed' fz='sm'>
          Today's Earnings
        </Text>
        <Text fw={700} fz='xl'>
          ${formatNumber(todaysEarnings)}
        </Text>
      </Card>
    </Grid.Col>
  </Grid>
)

export default EarningsSummaryCards
